import { render, staticRenderFns } from "./OthersDocuments.vue?vue&type=template&id=7da5966a"
import script from "./OthersDocuments.vue?vue&type=script&lang=js"
export * from "./OthersDocuments.vue?vue&type=script&lang=js"
import style0 from "./OthersDocuments.vue?vue&type=style&index=0&id=7da5966a&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-life-proof-portal/hive-life-proof-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7da5966a')) {
      api.createRecord('7da5966a', component.options)
    } else {
      api.reload('7da5966a', component.options)
    }
    module.hot.accept("./OthersDocuments.vue?vue&type=template&id=7da5966a", function () {
      api.rerender('7da5966a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OthersDocuments.vue"
export default component.exports